import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { BlacklistBookingsOptionsBase } from './BlacklistBookingsOptions'

import { blacklistBookingsSelector, isLoadingSelector } from 'reduxModules/selectors/BlacklistSelectors'
import { blacklistActions } from 'reduxModules/actions/BlacklistActions'

const mapStateToProps = createStructuredSelector({
  isLoading: isLoadingSelector,
  blacklistBookings: blacklistBookingsSelector,
})

const mapDispatchToProps = {
  deleteBlacklistBooking: blacklistActions.deleteBlacklistBooking
}

export const BlacklistBookingsOptions = connect(mapStateToProps, mapDispatchToProps)(BlacklistBookingsOptionsBase)




// WEBPACK FOOTER //
// ./src/components/BlacklistBookingsOptions/index.js